module.exports = __webpack_public_path__ + "static/media/23.cc98578a.mp3";